import PropTypes from 'prop-types';
import classNames from 'classnames';
import React from 'react';
import _ from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Glyphicon, OverlayTrigger, Tooltip } from '@bingads-webui-react/primitive';
import { submitEvent } from '@bingads-webui-universal/accessibility-helper';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { getPageMenuItemStyles } from '../styles/page-menu-item-styles';

const LandingPageSelector = ({
  classes,
  isPageEnabled,
  pageId,
  setLandingPage,
  isDefaultLandingPage,
  defaultLandingPageTooltipText,
}) => {
  const classNamesArray = [
    [classes.fallbackGlyph, 'fallback-glyph'],
    isDefaultLandingPage
      ? classes.selectedLandingPage
      : classes.notSelectedLandingPage,
  ];

  const className = classNames(classNamesArray);
  let activeGlyphicon;
  if (pageId === 'campaigns' || pageId === 'overview' || pageId === 'accounts-summary' || pageId === 'accounts-overview') {
    if (isDefaultLandingPage) {
      activeGlyphicon = <Glyphicon onClick={e => setLandingPage(pageId, e)} className={className} glyph="ba-HomeSolid" />;
    } else {
      activeGlyphicon = (
        <OverlayTrigger
          key="bottom"
          placement="bottom"
          overlay={
            <Tooltip id="tooltip-top">
              {defaultLandingPageTooltipText}
            </Tooltip>
          }
        >
          <div
            onClick={e => setLandingPage(pageId, e)}
            role="button"
            className={classNames([classes.landingPageButton, 'set-landing-page-button'])}
            tabIndex={0}
            onKeyDown={e => submitEvent(setLandingPage)(e, pageId, e)}
            aria-label={defaultLandingPageTooltipText}
            data-is-focusable
          >
            <Glyphicon
              className={className}
              glyph="ba-Home"
            />
          </div>
        </OverlayTrigger>);
    }
  } else if (!isPageEnabled) {
    activeGlyphicon = <Glyphicon className={classes.fallbackGlyph} glyph="ba-OpenInNewWindow" />;
  }

  return (
    <React.Fragment>
      {activeGlyphicon}
    </React.Fragment>

  );
};

LandingPageSelector.defaultProps = {
  setLandingPage: null,
  isDefaultLandingPage: null,
  defaultLandingPageTooltipText: '',
};

LandingPageSelector.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getPageMenuItemStyles({}, {}),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  isPageEnabled: PropTypes.bool.isRequired,
  pageId: PropTypes.string.isRequired,
  setLandingPage: PropTypes.func,
  isDefaultLandingPage: PropTypes.bool,
  defaultLandingPageTooltipText: PropTypes.string,
  permissions: PropTypes.shape({
  }).isRequired,
};

export default withPermissions(withDefaultStyles(LandingPageSelector, getPageMenuItemStyles));
